import { useCallback } from "react";

import { debounce } from "@tm/insurance/utils";
import { PARTNER } from "@tm/isomorphic-utils";
import {
  CheckButton,
  FormattedText,
  ImageComponent,
  SpanTag,
} from "@tm/static";
import { usePartnerContext } from "@tm/static/partnerContext";
import { useBreakpointV2 } from "@tm/ui-widgets";
import {
  BgText,
  CountryImg,
  CountryNameTxt,
  OtherCountyBtn,
  PopularCountry,
  PopularCountryItem,
  TripUpcoming,
} from "./TravelDetails.style";
import { IPopularCountry } from "./types";

const PopularCountryComp = ({
  popCountry,
  handleShowOtherCountry,
  otherCountryTxt,
  handlePopularCountrySelect,
  setIsSelectedError,
  setCountrySelectToastMsg,
}: IPopularCountry) => {
  const device = useBreakpointV2();
  const context = usePartnerContext();
  const isCheckedHandler = useCallback(
    (data: any) => {
      return data?.isSelected;
    },
    [popCountry]
  );

  const handleErrorToast = debounce(() => {
    setIsSelectedError(false);
    setCountrySelectToastMsg("");
  }, 3000);

  const handleCountrySelect = (item: any) => {
    if (item.isDisabled) {
      const isExclusiveCountrySelected = popCountry?.find(
        (item: any) => item.isExclusiveSelection && item.isSelected
      );

      if (
        isExclusiveCountrySelected &&
        !item?.isExclusiveSelection &&
        item.isDisabled
      ) {
        setCountrySelectToastMsg(
          "Selected country cannot be chosen for domestic coverage"
        );
        handleErrorToast();
      } else if (
        item?.isExclusiveSelection &&
        !isExclusiveCountrySelected &&
        item.isDisabled
      ) {
        setCountrySelectToastMsg(
          "India cannot be chosen for International Travel"
        );
        handleErrorToast();
      } else if (item.isDisabled) {
        setIsSelectedError(true);
        handleErrorToast();
      }
    } else {
      handlePopularCountrySelect(item.code);
    }
  };

  const getGrey = (item: any): boolean => {
    const isExclusiveCountrySelected = popCountry?.find(
      (country: any) => country.isExclusiveSelection && country.isSelected
    );

    if (
      isExclusiveCountrySelected &&
      !item.isExclusiveSelection &&
      item.isDisabled
    ) {
      return true;
    }
    if (item.isExclusiveSelection && item.isDisabled) {
      return true;
    }
    return false;
  };
  return (
    <PopularCountry>
      {popCountry &&
        popCountry.slice(0, 5).map((item: any, index: number) => {
          return (
            <PopularCountryItem
              listSelected={isCheckedHandler(item)}
              onClick={() => handleCountrySelect(item)}
              key={index}
            >
              {index !== popCountry.length && (
                <CheckButton
                  isDisabled={item.isDisabled}
                  greyOut={getGrey(item)}
                  isChecked={item.isDisabled ? true : isCheckedHandler(item)}
                >
                  {!item.img && item.name && <BgText>{item?.code}</BgText>}
                  {item.upcomingTrip && (
                    <TripUpcoming>TRIP UPCOMING</TripUpcoming>
                  )}
                  {item?.name && !item.subtitle && (
                    <CountryNameTxt title={item.name}>
                      {item?.name}
                    </CountryNameTxt>
                  )}
                  {item?.name && item.subtitle && (
                    <CountryNameTxt title={item.name + item.subtitle}>
                      {item?.name + " " + item.subtitle}
                    </CountryNameTxt>
                  )}
                </CheckButton>
              )}
              {item?.img && (
                <CountryImg>
                  <ImageComponent
                    width={device == "sm" ? "100%" : "80px"}
                    height={device == "lg" ? "80px" : "82px"}
                    src={item.img}
                    loading="eager"
                  />
                </CountryImg>
              )}
            </PopularCountryItem>
          );
        })}
      <OtherCountyBtn onClick={handleShowOtherCountry}>
        <ImageComponent
          width="24px"
          height="24px"
          src={
            context === PARTNER.MYBIZ
              ? "https://tripmoneycmsimgak.mmtcdn.com/img/Frame_27565_cc0104059a.png"
              : "https://tripmoneycmsimgak.mmtcdn.com/img/Search_Icon_ffe4fbfcc2.svg"
          }
          loading="eager"
        />
        <SpanTag
          fontSize="xs"
          fontWeight="bold"
          color={`var(--tm-accent-color)`}
        >
          <FormattedText value={otherCountryTxt} />
        </SpanTag>
      </OtherCountyBtn>
    </PopularCountry>
  );
};

export default PopularCountryComp;
